function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  height: 24,
  width: 24
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  height: 24,
  width: 24
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M21.15,8.07v10a1.23,1.23,0,0,1-1.23,1.23H3.3a1.23,1.23,0,0,1-1.23-1.23V6.38A1.23,1.23,0,0,1,3.3,5.15H17L14.4,7.76a2.12,2.12,0,0,0-.63,1.52v.8a1.84,1.84,0,0,0,1.84,1.84h.8a2.12,2.12,0,0,0,1.52-.63ZM6.07,17.43c0-1,0-1.92.11-2.78a8.68,8.68,0,0,0,3.34-2.38c1.23-1.53,1.18-3.18-.4-4s-2.8.16-3.48,2.24A16.26,16.26,0,0,0,5,13.77a10.72,10.72,0,0,1-1.18.31.65.65,0,0,0-.53.67A.61.61,0,0,0,4,15.3q.45-.09.87-.21c0,.75-.07,1.54-.07,2.37a.62.62,0,0,0,.72.61A.64.64,0,0,0,6.07,17.43Zm3.57-2L10.87,14l.05.42a.92.92,0,0,0,1.59.55l.57-.6.37.52a.93.93,0,0,0,1,.36l2.22-.63a.64.64,0,0,0,.47-.71.61.61,0,0,0-.77-.49l-2,.58-.46-.65a.87.87,0,0,0-.41-.32,1,1,0,0,0-1.05.26l-.35.36L12,13.14a.91.91,0,0,0-.69-.78.94.94,0,0,0-.94.32L8.69,14.6a.61.61,0,0,0,.14.93A.65.65,0,0,0,9.64,15.38ZM20.05,3.85l1-1a.62.62,0,0,1,.87,0l.92.92a.62.62,0,0,1,0,.87l-1,1ZM8.56,11.5a6.72,6.72,0,0,1-2.24,1.72,13.87,13.87,0,0,1,.49-2.3C7.29,9.46,7.83,9,8.57,9.4S9.35,10.51,8.56,11.5Zm8.5-1.08a.93.93,0,0,1-.65.27h-.8a.61.61,0,0,1-.61-.61v-.8a.93.93,0,0,1,.27-.65l3.91-3.91L21,6.51Z"
})));

var SvgSignature = function SvgSignature(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    fill: "#000000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignature, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/signature.03857370.svg";
export { ForwardRef as ReactComponent };